import React from 'react';
import { Redirect } from 'react-router-dom';   
import { connect } from 'react-redux';

import Header from './Header';
import Menu from './Menu';
import { caminhoAtual } from '../actions/CaminhoActions';

class Layout extends React.Component {
  componentWillReceiveProps (nextProps) {
    if (nextProps.path) {
      this.props.caminhoAtual(nextProps.path);
      this.props.title ? document.title = this.props.title + " | Alpha Ultrapress" : document.title = "Página não encontrada | Alpha Ultrapress";
    }
  }

  componentDidMount () {
    window.dispatchEvent(new Event('resize'));
  }
  
  render () {
    if (!this.props.usuario) {
      return <Redirect to="/login" />;
    }
    return (
      <React.Fragment>
        <Header/>
        <Menu path={this.props.location.pathname} links={
          this.props.usuario.tipo === "administrador" ?
            [
              { tipo: "unico", rota: "/", span: "Dashboard", icone: "fa-dashboard" },
              { tipo: "unico", rota: "/procedimentos", span: "Procedimentos", icone: "fa-tasks" },
              { tipo: "dropdown", rota: "/contratos", span: "Contratos", icone: "fa-file-text", sublinks: [
                { rota: "/contratos/novo", span: "Boas-vindas", icone: "fa-calendar-plus-o" },
                { rota: "/contratos/pesquisar", span: "Pesquisar", icone: "fa-search" },
                { rota: "/contratos/transferir", span: "Transferir", icone: "fa-exchange" },
                { rota: "/emails-automaticos", span: "E-mails automáticos", icone: "fa-paper-plane" },
                { rota: "/acessos-portal", span: "Acessos do portal", icone: "fa-line-chart" },
                // { rota: "/contratos/vincular", span: "Vincular", icone:"fa-link" }
              ]},
              { tipo: "dropdown", rota: "/publicacao", span: "Publicações", icone: "fa-envelope", sublinks: [
                { rota: "/publicacao", span: "Publicar", icone: "fa-plus" },
                { rota: "/publicacoes", span: "Buscar", icone: "fa-list" },
                { rota: "/contrato", span: "Visualizar", icone: "fa-eye" },
                { rota: "/fechar-publicacao",  span: "Fechar", icone: "fa-lock" }
              ]},
              { tipo: "unico", rota: "/convite-online", span: "Convite on-line", icone: "fa-book" },
              { tipo: "unico", rota: "/pesquisa-satisfacao", span: "Pesquisa de satisfação", icone: "fa-search" },
              { tipo: "unico", rota: "/videos", span: "Tutoriais da comissão", icone: "fa-play" },
              { tipo: "unico", rota: "/usuarios", span: "Usuários", icone: "fa-users" },
              { tipo: "unico", rota: "/buscar-cadastro", span: "Buscar cadastro", icone: "fa-id-card-o" },
            ]
          : this.props.usuario.tipo === "comum" ?
            [
              { tipo: "unico", rota: "/", span: "Dashboard", icone: "fa-dashboard" },
              { tipo: "dropdown", rota: "/contratos", span: "Contratos", icone: "fa-file-text", sublinks: [
                { rota: "/contratos/novo", span: "Aguardando cronograma", icone: "fa-calendar-plus-o" },
                { rota: "/contratos/pesquisar", span: "Pesquisar", icone: "fa-search" }
              ]},
              { tipo: "dropdown", rota: "/publicacao", span: "Publicações", icone: "fa-envelope", sublinks: [
                { rota: "/publicacao", span: "Publicar", icone: "fa-plus" },
                { rota: "/publicacoes", span: "Buscar", icone: "fa-list" },
                { rota: "/contrato", span: "Visualizar", icone: "fa-eye" },
                { rota: "/fechar-publicacao", span: "Fechar", icone: "fa-lock" }
              ]},
              { tipo: "unico", rota: "/convite-online", span: "Convite on-line", icone: "fa-book" }
            ]
          : this.props.usuario.tipo === "prod" ?
            [ { tipo: "unico", rota: "/contrato", span: "Visualizar", icone: "fa-eye" } ]
          : this.props.usuario.tipo === "mkt" ?
            [ 
              { tipo: "dropdown", rota: "/contratos", span: "Contratos", icone: "fa-file-text", sublinks: [
                { rota: "/contratos/pesquisar", span: "Pesquisar", icone: "fa-search" },
                { rota: "/contrato/info", span: "Detalhes", icone: "fa-folder" },
              ]},
              { tipo: "dropdown", rota: "/publicacao", span: "Publicações", icone: "fa-envelope", sublinks: [
                { rota: "/publicacoes", span: "Buscar", icone: "fa-list" },
                { rota: "/contrato", span: "Visualizar", icone: "fa-eye" },
              ]},
              { tipo: "unico", rota: "/pesquisa-satisfacao", span: "Pesquisa de satisfação", icone: "fa-search" },
            ]
          :
            [
              { tipo: "dropdown", rota: "/contratos", span: "Contratos", icone: "fa-file-text", sublinks: [
                { rota: "/contratos/novo", span: "Cadastrar", icone: "fa-calendar-plus-o" },
                { rota: "/contratos/pesquisar", span: "Pesquisar", icone: "fa-search" },
                { rota: "/contratos/vincular", span: "Vincular", icone: "fa-link" }
              ].concat(this.props.usuario.tipo === "orc"
                // Orcamentista (login "cad") acompanha os e-mails automaticos e os acessos do portal
                ? [
                  { rota: "/emails-automaticos", span: "E-mails automáticos", icone: "fa-paper-plane" },
                  { rota: "/acessos-portal", span: "Acessos do portal", icone: "fa-line-chart" }
                ]
                : [])},
              { tipo: "dropdown", rota: "/publicacao", span: "Publicações", icone: "fa-envelope", sublinks: [
                { rota: "/publicacoes", span: "Buscar", icone: "fa-list" },
                { rota: "/contrato", span: "Visualizar", icone: "fa-eye" },
              ]},
            ]
          }
        />
        <div className="content-wrapper height-full">
          <div className="content-header">
            <h1>
              {this.props.title}
              <span className="pull-right">{this.props.subtitle}</span>
            </h1>
          </div>
          <section className="content">
            <div className="row">
              <div className="col-md-12">
                {this.props.children}
              </div>
            </div>
          </section>
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado
  }
}
export default connect(mapStateToProps, {caminhoAtual})(Layout);



// WEBPACK FOOTER //
// ./src/components/Layout.js